import moment from 'moment';
import { SiteModuleEnum } from "../../../core/enum/site-module";
import { ScheduleEventAssignedStatus, IcdOfficeService } from "../../../core/services/data-services";
import { TimeSlotDecorator } from "../time-slot-decorator.service";
import templateUrl from './dashboard-scheduled-employees-review-container.html'
import { IQService } from 'angular';

export const DashboardScheduledEmployeesReviewContainerComponent = {
    templateUrl,
    controller: class DashboardSchedulesdEmployeesReviewContainerComponent {
        timeSlotDecorator: TimeSlotDecorator;
        pageNumber: number;
        pageSize: number;
        icdOffice: { value: number, text: string, Inactive: boolean };
        icdOffices: ({ value: number, text: string, Inactive: boolean })[];
        //TODO: Add type definitions.
        calendar: any;
        dropdownOptions;
        assignedScheduleEvents: any[];
        constructor(private $q: IQService, private eventHostService, private icdOfficeService: IcdOfficeService,
            private scheduleEventTimeSlotService, private utilityService) {
            'ngInject';

            this.calendar = {
                mode: "day",
                startDate: moment().startOf("day").toDate(),
                endDate: moment().endOf("day").toDate()
            };
            this.timeSlotDecorator = new TimeSlotDecorator({
                warnAboutUnassigned: true
            });
            this.pageNumber = 1;
            this.pageSize = 10;

        }

        $onInit() {
            
            const icdOfficesLoaded = this.icdOfficeService.retrieveIcdOffices({
                moduleID: SiteModuleEnum.EventsScheduling
            }).then(icdOffices => this.icdOffices = icdOffices.map(office => ({
                value: office.Id,
                text: `${office.OwnerName} - ${office.IcdCorporationName} (${office.OfficeName})`,
                Inactive: office.Inactive
            })));

            icdOfficesLoaded.then(() => {
                this.dropdownOptions = {
                    dataSource: new kendo.data.DataSource({
                        data: this.icdOffices,
                    }),
                    headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
                    open: () => {
                        setTimeout(() => {
                            const widget = $("#icdOfficeFilter").data("kendoDropDownList");
                            const source = this.icdOffices;
                            $("#allcorps").off("click").on("click", (e) => {
                                const isChecked = $(e.target).prop("checked");
                                const filtered = isChecked ? source.filter(c => c.Inactive === false) : source;
                                widget.dataSource.data(filtered);
                                widget.refresh();
                                widget.popup.open(); // keep it open after refresh
                            });
                        }, 0);
                    }
                }
                this.icdOffice = this.icdOffices.length === 1 ? this.icdOffices[0] : null;
                return this.loadAssignedScheduleEvents();
            })

        }

        onChangeIcdOffice() {
            const loadData = this.loadAssignedScheduleEvents();
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loadData, "Load failed")
            );
        }

        loadAssignedScheduleEvents() {
            if (!this.icdOffice) {
                this.assignedScheduleEvents = [];
                return this.$q.resolve([]);
            }
            const param = this.generateQueryParameter();
            return this.scheduleEventTimeSlotService
                .retrieveOfficeScheduleEventTimeSlots(this.icdOffice.value, param)
                .then(timeSlots => this.groupTimeSlotsByEmployees(timeSlots))
                .then(scheduleEvents => {
                    this.assignedScheduleEvents = scheduleEvents.map(p => this.mapScheduledEmployeesTimeSlots(p))
                    return this.assignedScheduleEvents
                })
        }

        generateQueryParameter() {
            const params = {
                StartDate: this.calendar.startDate,
                EndDate: this.calendar.endDate,
                AssignedStatus: ScheduleEventAssignedStatus.Accepted,
                IsAssigned: true
            }
            return params;
        }

        groupTimeSlotsByEmployees(timeSlots) {
            return timeSlots.reduce((ag, timeSlot) => {
                let employee = ag.dict[timeSlot.Employee.EmployeeID];
                if (!employee) {
                    employee = {
                        ...timeSlot.Employee,
                        TimeSlots: []
                    };
                    ag.dict[employee.EmployeeID] = employee;
                    ag.events.push(employee);
                }
                employee.TimeSlots.push({
                    TimeSlotAssignmentID: timeSlot.TimeSlotAssignmentID === 0 ? null :
                        timeSlot.TimeSlotAssignmentID,
                    StartDateTime: timeSlot.StartDateTime,
                    EndDateTime: timeSlot.EndDateTime,
                    ScheduleEvent: timeSlot.ScheduleEvent
                });

                return ag;
            }, { events: [], dict: {} }).events;
        }

        onChangeCalendar(calendar) {
            this.calendar.startDate = moment(calendar.startDate).startOf("day").toDate();
            this.calendar.endDate = moment(calendar.endDate).endOf("day").toDate();
            this.calendar.mode = calendar.mode;
            this.assignedScheduleEvents = [];
            const loadData = this.loadAssignedScheduleEvents();
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loadData, "Load failed")
            );
        }

        mapScheduledEmployeesTimeSlots(employee) {
            const employeeName = employee.FirstName + ' ' + employee.LastName;
            return {
                id: employee.EmployeeID,
                name: employeeName,
                description: '',
                readOnly: true,
                timeSlots: employee.TimeSlots.map(timeSlot => {
                    const eventNames = [
                        timeSlot.ScheduleEvent.HostLocationName,
                        timeSlot.ScheduleEvent.City
                    ].filter(p => p && p.trim())
                        .join(" - ");
                    const style = {
                        borderColor: "#215490",
                        backgroundColor: "#2764AB",
                        color: "#FDFDFD"
                    };
                    const dates = "(" + moment(timeSlot.ScheduleEvent.StartDate).format("MMM DD") + " - "
                        + moment(timeSlot.ScheduleEvent.EndDate).format("MMM DD") + ")";
                    return {
                        id: timeSlot.TimeSlotAssignmentID,
                        startDateTime: timeSlot.StartDateTime,
                        allDay: true,
                        deletable: false,
                        endDateTime: timeSlot.EndDateTime,
                        description: eventNames + " " + dates,
                        draggable: false,
                        style: {
                            ...style
                        },
                        Employee: employee ? {
                            Id: employee.EmployeeID
                        } : null
                    }
                })
            };
        }

        hydrateScheduleEvent(detail) {
            const eventHostLoaded = this.eventHostService.retrieveEventHost(detail.EventHostID)
                .then(eventHost => detail.EventHost = eventHost);

            return this.$q.all([eventHostLoaded])
                .then(() => detail);
        }
    }

};
